import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import {ActivatedRoute} from "@angular/router";
import { style, animate } from '@angular/animations';

@Component({
  selector: 'lc-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit {
  news_blocks = [];
  content_blocks = [];
  nav_background_class = 'none';

  fadeInBottom = [
    style({opacity: 0, transform: 'translateY(30px)'}),
    animate('1000ms cubic-bezier(0.35, 0, 0.25, 1)', style({opacity: 1, transform: 'translateY(0px)'}))
  ];

  constructor(public dataService: DataService) { }

  ngOnInit() {
    // TODO: the navbar seems to render more the just the navbar, this makes it confusing
    // if( this.dataService.main_country === 'AU' ){
    //  this.nav_background_class = 'dark--au';
    // }
    if( this.dataService.main_country === 'NL' && this.dataService.main_brand !== 'AVENT' ){
      this.nav_background_class = 'dark--eu';
    }
    if(!!this.dataService.home_content_blocks && this.dataService.home_content_blocks.length > 0){
      this.content_blocks = this.dataService.home_content_blocks;
    } else {
      this.load_page_data('HOME', 'content_blocks', 999);
    }
    if( !!this.dataService.news_available && this.dataService.news_count_home > 0){
      this.load_page_data('NEWS', 'news_blocks', this.dataService.news_count_home)
    }
  }

  load_page_data(page_name, col_name, max_blocks){
    this.dataService.get_page_content(page_name).subscribe(page =>{
      if( !!page &&!!page.sections && page.sections.length > 0){ 
        this[col_name] = [];
        for(let section of page.sections){
          let sec = section;
          try{
            let sec = JSON.parse(section);
          } catch(e) {
          }
          if( this[col_name].length < max_blocks ){
            this[col_name].push(sec);
          }
        }
      } else {
        this[col_name] = [];
      }
    }, err => {
      this[col_name] = [];
    });
  }  
}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/pages/home-page/home-page.component.ts